import { ACO, getPitStopTimes } from "./service.js";

export class LeMansCup extends ACO {
  constructor(...args) {
    super(
      'data.lemanscup.com',
      'Le Mans Cup',
      ...args
    );
  }

  postProcessCar(car, stints, parameters) {
    const pitIndex = 19;
    if (parameters.MIN_PIT_TIME_SECONDS) {
      const pitTimes = getPitStopTimes(stints[car[0]]);
      const timedStops = pitTimes.filter(t => t >= parameters.MIN_PIT_TIME_SECONDS);
      const hasMetObligations = timedStops.length >= 1;

      car[pitIndex][1] = hasMetObligations ? 'green' : 'red';

    }
  }
};

LeMansCup.regex = /live\.lemanscup\.com/;

LeMansCup.parametersSpec = {
  MIN_PIT_TIME_SECONDS: {
    description: 'Minimum duration of statutory pit stop, in seconds, as published by the race organisers',
    label: 'Reference pit stop time',
    type: 'number',
    minimum: 0,
    unit: 's'
  }
}
